import { IntegerFilterInput } from '@moonpig/web-explore-types-graphql'
import { StateIntegerFilter } from '../slices/filters/types'

export const getIntegerFilterInput = (
  integerFilters: StateIntegerFilter[] | undefined,
): IntegerFilterInput | undefined =>
  integerFilters && integerFilters.length > 0 && integerFilters[0].value
    ? {
        [integerFilters[0].integerId.toLowerCase()]: {
          min: integerFilters[0].value,
          max: integerFilters[0].value,
        },
      }
    : undefined
